import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {CoreSidebarService} from '../../../@core/components/core-sidebar/core-sidebar.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AlertService} from '../../shared/services/alert.service';
import {ArticleService} from '../../shared/services/article.service';

@Component({
    selector: 'app-articles',
    templateUrl: './articles.component.html',
    styleUrls: ['./articles.component.scss']
})
export class ArticlesComponent implements OnInit {
    showSearch = false;
    id: any;
    data: any;
    submitted: any = false;
    submitting: any = false;
    searchForm: FormGroup;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    articles = [];
    onFileChanged: any;
    viewContentData: any;

    constructor(private router: Router,
                private _coreSidebarService: CoreSidebarService,
                public modalService: NgbModal,
                private fb: FormBuilder,
                private articleService: ArticleService,
                private alertService: AlertService) {
    }

    ngOnInit(): void {
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-article').toggleOpen();
    }

    add(): void {
        this.data = undefined;
        this.toggleSidebar();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'heading': ['']
        });
        this.get();
    }


    getData(valueSubmit: any): void {
        if (valueSubmit) {
            this.get({page: 1, total: null, perpage: 15, pages: null});
            this.toggleSidebar();
        }
    }

    search() {
        const params = {
            'heading': (this.searchForm.value && this.searchForm.value.heading) ? this.searchForm.value.heading : ''
        };
        this.get(params);
    }

    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            category: (this.searchForm && this.searchForm.value && this.searchForm.value.category) ? this.searchForm.value.category : '',
            heading: (this.searchForm && this.searchForm.value && this.searchForm.value.heading) ? this.searchForm.value.heading : ''
        };
        this.get(params);
    }

    edit(data) {
        this.data = data;
        this.toggleSidebar();
    }

    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.articles = [];
        this.articleService.get(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.articles = data['data'];
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            } else {
                this.articles = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    articlesInfoPage(data: any) {
        this.router.navigateByUrl('article-info/' + data.id);
    }

    onFileChange(e, type, data) {
        this.onFileChanged = e;
        this.articleService.fileUploadAdmin({
            'type': type,
            'fileType': 'NORMAL',
            'insight_id': data.id
        }, this.onFileChanged).subscribe(data => {
            if (type === 'ARTICLE_BANNER' || type === 'ARTICLE_COVER') {
                if (data && data['data']) {
                    this.get();
                }
            }
            this.alertService.showSuccess({title: 'Success', message: 'Uploaded Successfully'});
        }, error => {
            this.alertService.showErrors('Something went wrong, please try again');
        });
    }

    openInsightBanner(data) {
        window.open(data['article_banner']['url'], '_blank');
    }
    openInsightcover(data) {
        window.open(data['article_cover']['url'], '_blank');
    }

    viewContent(content, data) {
        this.viewContentData = data;
        this.modalService.open(content);
    }

    updateStatus(data, status) {
        this.articleService.updateStatus(data.id, {'status': status}).subscribe(data => {
            this.submitting = false;
            this.submitted = false;
            this.get();
        }, error => {
            this.submitting = false;
            this.submitted = false;
        });
    }
    delete(id) {
        this.articleService.delete(id).subscribe(data => {
            this.get();
        });
    }
}
